export default __webpack_public_path__ + "static/media/07-ISIS.aa1f95bf.gif";